<script>
	import { Table } from "sveltestrap";
	export let detailData;
	import { statusMapStr } from "../../../utils/options";
	import TaskDetails from "./TaskDetails.svelte";

	let task = {};
	$: isOpen = false;
	function toggleDetails(idx) {
		task = detailData.job.tasks[idx];
		isOpen = !isOpen;
	}
</script>

<Table responsive hover>
	<thead>
		<tr>
			<th>Task Code</th>
			<th>Task</th>
			<th>Status</th>
			<th>Priority</th>
			<th>Planner's Remarks</th>
		</tr>
	</thead>
	<tbody>
		{#if detailData.job.tasks.length === 0}
			<tr>
				<td colspan="5">
					<b class="d-flex justify-content-center">
						No tasks for this job
					</b>
				</td>
			</tr>
		{:else}
			{#each detailData.job.tasks as { status, presetTask, plannerRemarks, priority }, idx}
				<tr class="cursor-pointer" on:click={() => toggleDetails(idx)}>
					<td>{presetTask.code}</td>
					<td>{presetTask.description}</td>
					<td>{@html statusMapStr[status]}</td>
					<td>{priority}</td>
					<td>{plannerRemarks}</td>
				</tr>
			{/each}
		{/if}
	</tbody>
</Table>
{#if isOpen}
	<TaskDetails {task} {toggleDetails} />
{/if}
